module.exports = __webpack_public_path__ + "static/img/kjdy20.b5339e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newestqianniu/kjdy20.png
// module id = 336
// module chunks = 0